import React, { useContext, useEffect, useState } from "react";
import PageWrapper from "../../components/PageWrapper/PageWrapper";
import { AsistenciaMedicaContext } from "../../contexts/AsistenciaMedicaContext";
import { IonCol, IonGrid, IonRow } from "@ionic/react";
import { Button, CardData, Modal, Separador, Subtitulo, TextLink, Texto1Linea, Titulo } from "app-principal-componentes-visuales";
import { capitalizeString, formatearNumeroInputCelular } from "../../utils/utils";
import { checkPermisosGeo, inicioLocationWeb } from "../../helpers/geolocalizacion";
import ModalEditarDatos from "../../components/Modals/EditarDatos/EditarDatos";
import Normalizacion from "../../components/Modals/Normalizacion/Normalizacion";
import LocalidadError from "../../components/Modals/LocalidadError/LocalidadError";
import ProximidadUbicacion from "../../components/Modals/ProximidadUbicacion/ProximidadUbicacion";
import { checkearGeolocalizacion } from "../../helpers/googleApi";
import { eliminarLocalidadStorage } from "../../utils/ubicacionUtils";
import { AsistenciaMedicaActionType } from "../../interfaces/global-state/asistencia.medica.action.type.enum";
import { CALLE_INTERNA, FORMULARIO_BARRIO_CERRADO, FORMULARIO_DOMICILIO, LOTE, SELECCIONAR_DOMICILIO, SINTOMAS, VERIFICAR_DATOS } from "../../utils/constants";
import { Direccion } from "../../interfaces/direccion.interface";
import SintomasSkeleton from "../../components/Skeletons/SintomasSkeleton/SintomasSkeleton";
import ReintentarPage from "../../components/ReintentarPage/ReintentarPage";
import { loadProvincias } from "../../contexts/actions/actions";
import { useDirecciones } from "../../hooks/useDirecciones";
import TipoFormulario from "../../components/Modals/TipoFormulario/TipoFormulario";
import './DatosContactoUbicacion.scss'

const DatosContactoUbicacion = ({history}) => {
    const { asistenciaMedica, dispatchAsistenciaMedica, storageManager, isWeb, useRequest } = useContext(AsistenciaMedicaContext);
    const { apiRequest } = useRequest();
    const socio = asistenciaMedica.socioSeleccionado;
    const socioPrincipal = asistenciaMedica.usuario;
    const statusModulos = asistenciaMedica.statusModulos;
    const selectedDirection = asistenciaMedica.direccionSeleccionada;
    const [showEditarDatosContactoModal, setShowEditarDatosContactoModal] = useState(false);
	const [proximidadModal, setProximidadModal] = useState(false);
    const [showTipoFormularioModal, setShowTipoFormularioModal] = useState(false);
	const [menorDireccionProxima, setMenorDireccionProxima] = useState(null);
    const direccionesSocio = socioPrincipal.direcciones;
    const [localidadError, setLocalidadError] = useState(false);
    const [provinceError, setProvinceError] = useState(false);
    const [loadingProvinces, setLoadingProvinces] = useState(false);
    const provinciasSinCargar = !asistenciaMedica.provincias || asistenciaMedica.provincias.length === 0;
    const {
        stateMerlin,
        edicionDireccion,
        handleNormalizacion,
        showNormalizacionModal,
        setShowNormalizacionModal,
        updateDirection,
        handleNormalizacionEditar,
        handleCloseModal,
        handleCloseModalEdit,
        foundSelected
    } = useDirecciones({socioPrincipal, apiRequest, direccionesSocio});

    useEffect(() => {
        dispatchAsistenciaMedica({
            type: AsistenciaMedicaActionType.actualizarDireccionSeleccionada,
            direccionSeleccionada: foundSelected(socioPrincipal.direcciones)
        })
    }, [socioPrincipal.direcciones])
    
    useEffect(() => {
        if((provinciasSinCargar) && provinceError === false) {
            setLoadingProvinces(true)
            setProvinceError(false)
            loadProvincias(apiRequest, dispatchAsistenciaMedica, setProvinceError, setLoadingProvinces)
        }
    }, [asistenciaMedica.provincias, provinceError])

    useEffect(() => {
        if(provinciasSinCargar) return;
        isWeb ? inicioLocationWeb(dispatchAsistenciaMedica) : checkPermisosGeo(dispatchAsistenciaMedica);
    }, [provinciasSinCargar]);

    const disableButtonContinuar = localidadError || !selectedDirection || !socio.telefono || !socio.email

    const openModalContacto = () => {
        setShowEditarDatosContactoModal(!showEditarDatosContactoModal);
    };

    const onHandleEditarDireccion = (selectedDirectionAux: Direccion) => {
        const isBarrioCerrado = selectedDirectionAux?.barrioCerrado;
        history.push(
            isBarrioCerrado ? 
            FORMULARIO_BARRIO_CERRADO :
            FORMULARIO_DOMICILIO, {
                selectedDirection: selectedDirectionAux,
                showEliminar: true
            }
        ) 
    }

    const onHandleShowTipoFormularioModal = () => {
        setShowTipoFormularioModal(true); 
    }

    const handleClickValidarProximidad = () => {
        if(!statusModulos?.deshabilitarGeolocalizacionExacta) {
            checkearGeolocalizacion(direccionesSocio, selectedDirection, asistenciaMedica?.geolocalizacion)
                .then(resultado => {
                    if (resultado) {
                        setMenorDireccionProxima(resultado);
                        setProximidadModal(true);
                    } else {
                        handleClick();
                    }
                })
                .catch(() => {
                    handleClick();
                })
        }else{
            handleClick();
        }
	}

    const handleClick = (foundAddress = null) => {
		let dirSeleccionada = foundAddress ? foundAddress : selectedDirection;
		if (selectedDirection.provincia === 'BUENOS AIRES' && (selectedDirection.localidad === 'CIUDAD AUTONOMA BUENOS AIRES' || selectedDirection.localidad === 'CAPITAL FEDERAL')) {
			if (!localidadError) {
				eliminarLocalidadStorage(storageManager);
				setLocalidadError(true);
			}
		} else {
			dispatchAsistenciaMedica({
				type: AsistenciaMedicaActionType.actualizarSintomas,
				sintomas: []
			})

			dispatchAsistenciaMedica({
				type: AsistenciaMedicaActionType.actualizarDireccionSeleccionada,
				direccionSeleccionada: dirSeleccionada
			})
			history.replace(SINTOMAS);
		}
	}


    /**
	 * actualiza la direccion seleccionada por proximidad
	 */
	const handleClickCambiarDireccionProximidad = () => {
		let direccionesAux: Direccion[] = direccionesSocio;
		direccionesAux.forEach(direccion => {
			direccion.seleccionado = (direccion.id === menorDireccionProxima.id)
		});
		const foundAddress = foundSelected(socio.direcciones);
        dispatchAsistenciaMedica({
            type: AsistenciaMedicaActionType.actualizarDireccionSeleccionada,
            direccionSeleccionada: foundAddress
        })
		updateDirection(direccionesAux);
		handleClick(foundAddress);
	}

    if(loadingProvinces) {
		return (
			<PageWrapper 
				socio={asistenciaMedica.usuario} 
				pageClassName="asistencia-seleccionar-domicilio"
				path={VERIFICAR_DATOS}
				className="verificar-datos-grid"
				>
				<SintomasSkeleton />
			</PageWrapper>)
	}

	if(provinceError && !selectedDirection) {
		return (
			<PageWrapper 
				socio={asistenciaMedica.usuario} 
				pageClassName="asistencia-seleccionar-domicilio"
				path={VERIFICAR_DATOS} className="reintentar-page" 
				>
				<ReintentarPage onClick={ () => { setProvinceError(false)} } />
			</PageWrapper>
		)
	}

    return (
        <>
            <PageWrapper pageClassName="asistencia-verificar-datos-contacto asistencia-seleccionar-domicilio" className="verificar-datos-grid" path={VERIFICAR_DATOS} socio={socioPrincipal} >
                <div>
                    <div>
                        <IonRow>
                            <IonCol size='12'>
                                <Titulo
                                    className='asistencia-titulo-confirma-datos'
                                    titulo={`Completá los datos para esta asistencia ${capitalizeString(socio.nombre)} `}
                                    id="titulo-asistencia-confirma-datos"
                                />
                                <Subtitulo
                                    titulo="Datos de contacto"
                                    txt16
                                    id="subtitulo-solicitud"
                                />
                                <Subtitulo
                                    titulo="Nos permitirán contactarte en caso de que sea necesario para resolver esta solicitud."
                                    txt16
                                    id="subtitulo-solicitud"
                                />
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol size='12'>
                                <Texto1Linea
                                    left
                                    txt16
                                    texto={!socio.telefono ? "No hay numero de telefono asociado" : formatearNumeroInputCelular(socio.telefono)}
                                />
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol size='12'>
                                <Texto1Linea
                                    left
                                    txt16
                                    texto={!socio.email ? "No hay email asociado" : socio.email}
                                />
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol size="12">
                                <TextLink
                                    id="verificar-datos-editar"
                                    onClick={openModalContacto}
                                    left
                                    texto="Editar datos"
                                />
                            </IonCol>
                        </IonRow>
                    </div>
                    <Separador />
                    <div>
                        <IonRow>
                            <IonCol size='12'>
                                <Subtitulo
                                    titulo="Datos de ubicación"
                                    txt16
                                    id="subtitulo-solicitud"
                                />
                                <Subtitulo
                                    titulo="Debe corresponder al lugar donde se realizará la asistencia médica."
                                    txt16
                                    id="subtitulo-solicitud"
                                />
                            </IonCol>
                        </IonRow>
                        {
                            !selectedDirection ?
                                <>
                                    <IonGrid>
                                        {/* <IonRow>
                                            <Titulo className="sd__title" titulo={"Ingresá un domicilio"} id="titulo-asistencia-seleccionar-domicilio" />
                                        </IonRow>
                                        <IonRow>
                                            <Subtitulo txt16 titulo={"Debe corresponder al lugar donde se encontrará para recibir la asistencia médica."} id="subtitulo-seleccionar-domicilio" />
                                        </IonRow> */}
                                        <IonRow>
                                            <Subtitulo txt16 className="domicilios_card" txtCenter titulo={"No tenés domicilios registrados"} id="subtitulo-domicilio" />
                                        </IonRow>
                                        {
                                            socio?.telefono && socio?.email &&
                                            <IonRow className="form__link">
                                                <TextLink 
                                                    id="asistencia__seleccionar-domicilio" 
                                                    texto="Agregar un nuevo domicilio" 
                                                    onClick={onHandleShowTipoFormularioModal} 
                                                />
                                            </IonRow>
                                        }
                                    </IonGrid>
                                </>
                                :
                                <>
                                    <IonGrid>
                                        <IonRow>
                                            <IonCol size='12'>
                                                <CardData
                                                    asistencia
                                                    direccion={
                                                        capitalizeString(
                                                            `${selectedDirection?.calle} ${
                                                                !selectedDirection?.barrioCerrado ? 
                                                                `${selectedDirection?.altura}${selectedDirection?.barrio && ', ' + selectedDirection?.barrio}` 
                                                                : ''
                                                            }`)
                                                    }
                                                    id="asistencia-direccion-editar"
                                                    linkEdit="Editar"
                                                    onClick={() => onHandleEditarDireccion(selectedDirection)}
                                                    texto={<>{
                                                        capitalizeString(selectedDirection?.localidad)}
                                                            <br />{
                                                                capitalizeString(
                                                                selectedDirection?.barrioCerrado ?
                                                                    selectedDirection?.observaciones?.split(`${CALLE_INTERNA}:`)?.[1]?.split(`-`)?.[0] ?? '' :
                                                                    selectedDirection?.observaciones ?? ''
                                                                )
                                                            }
                                                        </>}
                                                />
                                            </IonCol>
                                        </IonRow>
                                        {
                                            socio?.telefono && socio?.email &&
                                                <IonRow className="form__link">
                                                    <TextLink 
                                                        id="asistencia__form-link" 
                                                        texto="Seleccionar otro domicilio" 
                                                        onClick={() => history.replace(SELECCIONAR_DOMICILIO)} 
                                                    />
                                                </IonRow>
                                        }
                                    </IonGrid>
                                    
                                </>
                        }
                    </div>
                </div>
                <Button
                    id="seleccionar-domicilio-continuar"
                    className='seleccionar-domicilio__button'
                    key="continue_button"
                    primary
                    onClick={handleClickValidarProximidad}
                    label={"Continuar"}
                    disable={disableButtonContinuar}
                />
            </PageWrapper>
            <Modal
                className='modal_web'
                //@ts-ignore
                component={<ModalEditarDatos selectedAssociate={socio} modifyAssociate={() => setShowEditarDatosContactoModal(!showEditarDatosContactoModal)} dispatchAsistenciaMedica={dispatchAsistenciaMedica} />}
                setShowModal={setShowEditarDatosContactoModal}
                showModal={showEditarDatosContactoModal}
                id="datos-contacto-modal"
            />
            <Modal
                className='modal_web'
                //@ts-ignore
                component={ 
                    <TipoFormulario 
                        pathDomicilio={FORMULARIO_DOMICILIO}
                        pathBarrioCerrado={FORMULARIO_BARRIO_CERRADO}
                        propsBarrioCerrado={{redirectTo:SINTOMAS, fromState:VERIFICAR_DATOS}}
                        propsDomicilio={{redirectTo:SINTOMAS, fromState:VERIFICAR_DATOS}}  
                    /> 
                }
                setShowModal={setShowTipoFormularioModal}
                showModal={showTipoFormularioModal}
                id="tipo-formulario-modal" 
            />
            {
                !selectedDirection ?
                    <>
                        <Modal
                            screen60
                            hideCloseBtn
                            className='modal_web'
                            //@ts-ignore
                            component={
                                <Normalizacion
                                    onClick={edicionDireccion ? handleNormalizacionEditar : handleNormalizacion}
                                    closeModal={edicionDireccion ? handleCloseModalEdit : handleCloseModal}
                                    data={stateMerlin}
                                    isWeb={isWeb}
                                />
                            }
                            setShowModal={setShowNormalizacionModal}
                            showModal={showNormalizacionModal}
                            id="modal-normalizacion"
                        />
                    </>
                    :
                    <>
                        <Modal
                            screen60
                            hideCloseBtn
                            //@ts-ignore
                            className='modal_web'
                            component={
                                <Normalizacion
                                    onClick={edicionDireccion ? handleNormalizacionEditar : handleNormalizacion}
                                    closeModal={edicionDireccion ? handleCloseModalEdit : handleCloseModal}
                                    data={stateMerlin}
                                    isWeb={isWeb}
                                />
                            }
                            setShowModal={setShowNormalizacionModal}
                            showModal={showNormalizacionModal}
                            id="modal-normalizacion"
                        />
                        <Modal
                            screen60
                            hideCloseBtn
                            //@ts-ignore
                            component={
                                <LocalidadError
                                    setLocalidadError={setLocalidadError}
                                />
                            }
                            setShowModal={setLocalidadError}
                            showModal={localidadError}
                            id="modal-localidad-error"
                        />
                        <Modal
                            screen60
                            className="modal_web"
                            component={
                                <ProximidadUbicacion
                                    onClickContinuar={handleClick}
                                    onClickCambiarDireccion={handleClickCambiarDireccionProximidad}
                                    direccionMasProxima={menorDireccionProxima}
                                />
                            }
                            setShowModal={setProximidadModal}
                            showModal={proximidadModal}
                            id="modal-proximidad-ubicacion"
                        />
                    </>

            }
        </>
    )

}

export default DatosContactoUbicacion;